module.exports = __webpack_public_path__ + "img/16_90.3db01225.png";